import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { GenericBaseService } from './generic-base.service';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})

export class AuditLogService extends GenericBaseService {

  constructor(
    protected httpClient: HttpClient,
    protected toastrService: ToastrService,
    protected url: UrlService
  ) {
    super('Audit Logs', httpClient, toastrService, url);
  }
}
